import { render, staticRenderFns } from "./rechagriew.vue?vue&type=template&id=4cb9b649&scoped=true&"
import script from "./rechagriew.vue?vue&type=script&lang=js&"
export * from "./rechagriew.vue?vue&type=script&lang=js&"
import style0 from "./rechagriew.vue?vue&type=style&index=0&id=4cb9b649&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb9b649",
  null
  
)

export default component.exports